import React, { useCallback, useEffect, useState } from "react";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Heading,
  ListItem,
  UnorderedList,
  Divider,
  Text,
  Flex,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";
import { Container, LoginTitle } from "./styled";
import { mainTheme } from "../../config/theme";
import { getUrlParams } from "../../services/utils";
import { Payment, Subscription } from "../../types";

export const Stripe: React.FC = observer(() => {
  const { session, clientsStore } = useStores();

  const [subscriptionNotActivated, setSubscriptionNotActivated] =
    useState(false);
  const [stripePortalSuccess, setStripePortalSuccess] = useState(false);
  const [subscriptionRetrieved, setSubscriptionRetrieved] =
    useState<null | Subscription>(null);
  const [payments, setPayments] = useState<null | Payment[]>(null);

  const checkStripeNoSubscription = useCallback(async () => {
    const params = getUrlParams(window.location.hash);
    if (params.cancel) {
      setSubscriptionNotActivated(true);
    }
  }, []);

  const checkStripePortalSuccess = useCallback(async () => {
    const params = getUrlParams(window.location.hash);
    if (params.backFromPortal) {
      setStripePortalSuccess(true);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("DOMContentLoaded", checkStripeNoSubscription);
    document.addEventListener("DOMContentLoaded", checkStripePortalSuccess);
  }, [checkStripeNoSubscription, checkStripePortalSuccess]);

  const handleCheckout = useCallback(async () => {
    setSubscriptionNotActivated(false);
    try {
      await session.stripeCheckout();
    } catch (err) {
      console.log(err);
    }
  }, [session]);

  const handlePortalAccess = useCallback(async () => {
    setStripePortalSuccess(false);
    try {
      const portalSessionUrl = await session.stripeAccessPortal();
      // Redirect to Portal
      if (!!portalSessionUrl) {
        window.location.replace(portalSessionUrl);
      }
    } catch (err) {
      console.log(err);
    }
  }, [session]);

  const handleGetSubscription = useCallback(async () => {
    try {
      // TODO: when calling this function, pass the correct stripe subscription ID
      const subscription = await clientsStore.getStripeSubscription(
        "sub_Jyj9TySCYHidGB"
      );
      // setSubscriptionRetrieved(subscription);
    } catch (err) {
      console.log(err);
    }
  }, [clientsStore]);

  const handleGetPayments = useCallback(async () => {
    try {
      // TODO: when calling this function, pass the correct customer ID
      const paymentsList = await clientsStore.getPayments("cus_Jyeci757hrCfMT");

      console.log(paymentsList);
      //setPayments(paymentsList);
    } catch (err) {
      console.log(err);
    }
  }, [clientsStore]);

  // TODO: Style page
  return (
    <Container>
      <Box
        boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
        p="32px"
        rounded="32px"
        bg="white"
        minH="400px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <div style={{ textAlign: "center", width: "400px" }}>
          <LoginTitle>Stripe</LoginTitle>
        </div>
        <div>
          <Heading>Checkout</Heading>
          {session.stripeCheckoutError ||
            (subscriptionNotActivated && (
              <Alert
                status={"error"}
                color={mainTheme.colors.danger}
                borderRadius={"5px"}
                margin={"2rem 0"}
              >
                <AlertIcon />
                {/* TODO: add i18n */}
                {subscriptionNotActivated
                  ? "Subscription not activated"
                  : "Checkut Error"}
              </Alert>
            ))}
          <Button
            onClick={handleCheckout}
            colorScheme={"blue"}
            disabled={session.isSubmitting}
          >
            Checkout
          </Button>
        </div>
        <Divider p={10} />
        <div>
          <Heading>Access Portal</Heading>
          <Alert
            status={"error"}
            color={mainTheme.colors.danger}
            borderRadius={"5px"}
            margin={"2rem 0"}
          >
            <AlertIcon />
            Note: check if user stripeID is not null/undefined before going to
            the portal page
          </Alert>
          <UnorderedList>
            <ListItem>Cancel/pause user subscription</ListItem>
            <ListItem>Edit Payment method</ListItem>
            <ListItem>Show list of payments</ListItem>
          </UnorderedList>
          {stripePortalSuccess && (
            <Alert
              status={"success"}
              color={mainTheme.colors.secondaryText1}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <AlertIcon />
              {/* TODO: add i18n */}
              Portal edit ok
            </Alert>
          )}
          {session.stripePortalError && (
            <Alert
              status={"error"}
              color={mainTheme.colors.danger}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <AlertIcon />
              {/* TODO: add i18n */}
              Cannot access Stripe Portal
            </Alert>
          )}
          <Button
            onClick={handlePortalAccess}
            colorScheme={"blue"}
            disabled={session.isSubmitting}
          >
            Access Portal
          </Button>
        </div>
        <Divider p={10} />

        <div>
          <Heading>Informzioni subscription</Heading>
          {clientsStore.stripeSubscriptionError && (
            <Alert
              status={"error"}
              color={mainTheme.colors.danger}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <AlertIcon />
              {/* TODO: add i18n */}
              Informazioni abbonamento mancanti
            </Alert>
          )}
          {!!subscriptionRetrieved && (
            <Alert
              status={"success"}
              color={mainTheme.colors.secondaryText1}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <Flex flexDirection={"column"} display={"flex"}>
                {Object.keys(subscriptionRetrieved).map((key) => {
                  return (
                    <Box w={"100%"} flexDirection={"row"}>
                      <Text>{key}</Text>
                      <Text fontWeight={"bold"}>
                        {key !== "plan" ? (
                          subscriptionRetrieved[
                            key as keyof Subscription
                          ]?.toString()
                        ) : (
                          <Box w={"100%"} flexDirection={"row"}>
                            <Text fontWeight={"normal"}>id</Text>
                            <Text>{subscriptionRetrieved.plan.id}</Text>
                            <Divider p={2} />
                            <Text fontWeight={"normal"}>product</Text>
                            <Text>{subscriptionRetrieved.plan.product}</Text>
                            <Divider p={2} />
                            <Text fontWeight={"normal"}>amount</Text>
                            <Text>{subscriptionRetrieved.plan.amount}</Text>
                            <Divider p={2} />
                            <Text fontWeight={"normal"}>productName</Text>
                            <Text>
                              {subscriptionRetrieved.plan.productName}
                            </Text>
                            <Divider p={2} />
                          </Box>
                        )}
                      </Text>
                      <Divider p={2} />
                    </Box>
                  );
                })}
              </Flex>
            </Alert>
          )}
          <Button
            onClick={handleGetSubscription}
            colorScheme={"blue"}
            disabled={session.isSubmitting}
          >
            Richiedi Info
          </Button>
        </div>
        <Divider p={10} />

        <div>
          <Heading>List of Customer Payments</Heading>
          {clientsStore.stripePaymentsError && (
            <Alert
              status={"error"}
              color={mainTheme.colors.danger}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <AlertIcon />
              {/* TODO: add i18n */}
              Impossibile recuperare la lista pagamenti
            </Alert>
          )}
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>id</Th>
                <Th>amount</Th>
                <Th>currency</Th>
                <Th>created</Th>
                <Th>customer</Th>
                <Th>paid</Th>
                <Th>refunded</Th>
                <Th>status</Th>
              </Tr>
            </Thead>{" "}
            <Tbody>
              {!!payments ? (
                payments.map((payment) => {
                  return (
                    <Tr>
                      <Th>{payment.id}</Th>
                      <Th>{payment.amount}</Th>
                      <Th>{payment.currency}</Th>
                      <Th>{payment.created.toString()}</Th>
                      <Th>{payment.customer}</Th>
                      <Th>{payment.paid}</Th>
                      <Th>{payment.refunded}</Th>
                      <Th>{payment.status}</Th>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Td>No payments</Td>
                </Tr>
              )}{" "}
            </Tbody>{" "}
          </Table>
          <Button
            onClick={handleGetPayments}
            colorScheme={"blue"}
            disabled={session.isSubmitting}
          >
            Mostra pagamenti
          </Button>
        </div>
      </Box>
    </Container>
  );
});
